// extracted by mini-css-extract-plugin
export default {"root":"FoldersView_root__tOYUX","title":"FoldersView_title__faQaZ"};